import { Product } from '@dfds-frontend/tracking'

import { Departure } from '@/states/selection.interface'

import { TrackingData } from '../_actions/getTrackingData'
import { trackAddToCartSegment, trackRemoveFromCartSegment } from '../_actions/trackCartSegment'
import {
  AddonRemovalDeparture,
  buildAddonCartPayload,
  buildAddonRemovalCartPayload,
  buildDepartureCartPayload,
  buildPetCartPayload,
  DepartureTrackingContext,
} from './cartPayload'

type Leg = 'out' | 'home'

export const trackAddonAddedSegment = (leg: Leg, trackingData: TrackingData, product: Product, currency?: string): void => {
  const payload = buildAddonCartPayload(leg, trackingData, product, currency)
  if (payload) void trackAddToCartSegment(payload)
}

export const trackAddonRemovedSegment = (leg: Leg, trackingData: TrackingData, product: Product, currency?: string): void => {
  const payload = buildAddonCartPayload(leg, trackingData, product, currency)
  if (payload?.departureDate) void trackRemoveFromCartSegment(payload)
}

export const trackAddonRemovalSegment = (
  leg: Leg,
  departure: AddonRemovalDeparture,
  product: Product,
  context: DepartureTrackingContext
): void => {
  const payload = buildAddonRemovalCartPayload(leg, departure, product, context)
  if (payload?.departureDate) void trackRemoveFromCartSegment(payload)
}

export const trackPetAddedSegment = (leg: Leg, trackingData: TrackingData, product: Product, petCount: number, currency?: string): void => {
  const payload = buildPetCartPayload(leg, trackingData, product, petCount, currency)
  if (payload) void trackAddToCartSegment(payload)
}

export const trackPetRemovedSegment = (
  leg: Leg,
  trackingData: TrackingData,
  product: Product,
  petCount: number,
  currency?: string
): void => {
  const payload = buildPetCartPayload(leg, trackingData, product, petCount, currency)
  if (payload?.departureDate) void trackRemoveFromCartSegment(payload)
}

export const trackDepartureAddedSegment = (leg: Leg, departure: Departure, context: DepartureTrackingContext): void => {
  const payload = buildDepartureCartPayload(leg, departure, context)
  if (payload) void trackAddToCartSegment(payload)
}

export const trackDepartureRemovedSegment = (leg: Leg, departure: Departure, context: DepartureTrackingContext): void => {
  const payload = buildDepartureCartPayload(leg, departure, context)
  if (payload?.departureDate) void trackRemoveFromCartSegment(payload)
}
